import React from 'react';
import PropTypes from 'prop-types';
import { useTranslation } from 'react-i18next';
import { useQuery } from '@apollo/client';
import { companyNameQuery } from '../../queries';
import useBugsnagNotifier from '../../hooks/useBugsnagNotifier';
import config from '../../config';
import { makeUrlWithLang } from '../../utils/helpers';
import Profile from '../../public/static/images/tab_bar/cabinet.svg';
import Icon from '../Icon';

const TabBarItemAuth = ({ onClick, children }) => {
  const {
    t,
    i18n: { language: lang }
  } = useTranslation();
  const { data, error } = useQuery(companyNameQuery, {
    ssr: false,
    fetchPolicy: 'network-only'
  });
  const { protocol, host } = config;
  const profileName = (data && data.profile) || {};
  const phoneOrName = profileName.phone || profileName.name;
  const hostString = path => makeUrlWithLang({ protocol, host, path, lang });

  useBugsnagNotifier(error);

  return phoneOrName ? (
    <a
      className="tab-bar__link"
      href={hostString('/profile')}
      data-cy="profile-link"
      data-stat="tab-bar-profile-link"
    >
      <i className={'tab-bar__icon'}>
        <Icon
          indent={false}
          width={20}
          height={20}
          color="brown"
          IconComponent={Profile}
        />
      </i>
      <span className="tab-bar__link-text">
        {t('pages.tab_bar.buttons.cabinet')}
      </span>
    </a>
  ) : (
    <div
      role="button"
      onKeyPress={onClick}
      onClick={onClick}
      className={'tab-bar__link'}
      tabIndex={0}
      data-cy="login-button"
      data-stat="tab-bar-login-link"
    >
      {children}
    </div>
  );
};

TabBarItemAuth.propTypes = {
  onClick: PropTypes.func.isRequired,
  children: PropTypes.node.isRequired
};

export default TabBarItemAuth;
